<div id="containerMonthlyGraph"></div>